// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"InfoPanel_text-gradient__1nR2X","note":"InfoPanel_note__NiBRr","infoIcon":"InfoPanel_infoIcon__XVHHg"};